import React, { useState , useEffect } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import API from "../../api/axiosConfig";
import TableComponent from "../../components/TableComponent";

function DonationsReport(props) {
    const columns = [
        { name: "إسم المانح", key: "donorname" },
        { name: "رقم الجوال", key: "donorphone" },
        { name: "قيمة التبرع", key: "amount" },
        { name: "", key: "actions" },
    ];

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState({});

   
    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const navigate = useNavigate();


    const dropdownOptions = [
        { label: "تفاصيل المدفوعات", route: "/donationDetails/:id" },
    ];
    

    const modifyRow = (row) => {
       let newRow = { ...row };
        newRow.amount = new Intl.NumberFormat().format(row.amount) + " ريال";
        //newRow.donorphone = parse(row.donorphone);
        return newRow;
    }
 
    return (
        <>
            <div className="printcasedata-container">
                
                <TableComponent
                    apiUrl="/shoptransaction/case/totalrecieved"
                    columns={columns}
                    title="تقرير المدفوعات"
                    titleIcon={<FontAwesomeIcon icon={faPrint} />}
                    dropdownOptions = {dropdownOptions}
                    transformRowFn={modifyRow}
                    searchTextProp={true}
                    searchDate={false}
                />
            </div>
        </>
    );
}

export default DonationsReport;
